/* Compte a rebours de la promo (2026-10-11). Un seul script pour les trois emplacements
   (bandeau du haut, fiche produit, panier) : il remplit les elements [data-gh-rebours].

   - Charge seulement si la promo « cadeaux par paliers » est activee, sa date de fin
     renseignee et au moins un emplacement allume (sections/developly-cart.liquid).
   - La fin est une date en heure de Paris, convertie en instant : le compte est le meme
     quel que soit le fuseau du visiteur, et n'est jamais remis a zero.
   - Heure de reference : celle du serveur quand le panier l'a relevee (meme horloge que
     l'ajout et le retrait des cadeaux).
   - Sans JavaScript, les emplacements restent vides : jamais de compteur fige.
   - Lecteurs d'ecran : une phrase fixe avec la date de fin ; les chiffres qui bougent sont
     caches (aria-hidden), aucune zone « live ». */
(function () {
  'use strict';
  var source = document.getElementById('gh-rebours-config');
  var cart = window.developlyCart;
  if (!source || !cart || typeof cart._parisTime !== 'function') return;
  var cfg;
  try { cfg = JSON.parse(source.textContent); } catch (e) { return; }
  var end = cart._parisTime(cfg.fin);
  var start = cart._parisTime(cfg.debut);
  if (typeof end !== 'number' || start === false) return;   /* date vide ou illisible : rien */

  /* Shopify echappe les textes traduits (« jusqu&#39;à ») : on les remet en clair une fois,
     ils sont re-echappes au moment de l'affichage. */
  var clair = document.createElement('textarea');
  var T = {};
  Object.keys(cfg.textes || {}).forEach(function (k) {
    clair.innerHTML = String(cfg.textes[k] == null ? '' : cfg.textes[k]);
    T[k] = clair.value;
  });
  var ON = cfg.emplacements || {};
  var lang = ['fr', 'it', 'es', 'pt-PT', 'de'].indexOf(cfg.langue) > -1 ? cfg.langue : 'fr';
  var PARIS = 'Europe/Paris';
  var NBSP = ' ';
  var timer = null;
  var ended = false;
  var HORLOGE = '<svg class="gh-rebours__ico" width="14" height="14" viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="6.3" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M8 4.4V8l2.4 1.6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function now() { return Date.now() + (cart._giftSkew || 0); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* 3 j 04 h 12 min · 4 h 12 min · 12 min 05 s · 40 s */
  /* 15/10/2026 (Alex : « ça manque des secondes qui défilent ») : secondes toujours affichées sur la fiche et le panier ;
     le bandeau, plus étroit, garde l'affichage sans secondes au-delà d'une heure. */
  /* Barre d'urgence (19/10/2026, Alex : « pas assez visible », « les secondes qui tournent ») : 2 J 08:22:14 */
  function resteHorloge(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var j = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
    return (j > 0 ? j + NBSP + T.u_j + ' ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
  }

  function reste(ms, secondes) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var j = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
    var u = function (n, unit) { return n + NBSP + unit; };
    var fin = secondes ? ' ' + u(pad(sec), T.u_s) : '';
    if (j > 0) return u(j, T.u_j) + ' ' + u(pad(h), T.u_h) + ' ' + u(pad(m), T.u_min) + fin;
    if (h > 0) return u(h, T.u_h) + ' ' + u(pad(m), T.u_min) + fin;
    if (m > 0) return u(m, T.u_min) + ' ' + u(pad(sec), T.u_s);
    return u(sec, T.u_s);
  }

  function parts(t, opts) {
    var o = {};
    opts.timeZone = PARIS;
    new Intl.DateTimeFormat(lang, opts).formatToParts(new Date(t)).forEach(function (p) { o[p.type] = p.value; });
    return o;
  }

  /* « dimanche minuit », « dimanche 18 h 00 » : le jour et l'heure viennent de la date de fin
     (heure de Paris). 23 h 59 se lit minuit. A plus de 6 jours, le jour du mois est ajoute. */
  function quand() {
    try {
      var t = end;
      var hm = parts(t, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
      if (+hm.minute === 59) { t += 60000; hm = parts(t, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); }
      var minuit = +hm.hour === 0 && +hm.minute === 0;
      var loin = end - now() > 6 * 86400000;
      var day = new Intl.DateTimeFormat(lang, loin
        ? { weekday: 'long', day: 'numeric', month: 'long', timeZone: PARIS }
        : { weekday: 'long', timeZone: PARIS }).format(new Date(minuit ? t - 60000 : t));
      if (minuit) return String(T.quand_minuit || '').replace('__DAY__', day);
      var time = String(T.heure || '').replace('__H__', String(+hm.hour)).replace('__M__', hm.minute);
      return String(T.quand_heure || '').replace('__DAY__', day).replace('__TIME__', time);
    } catch (e) {
      return '';
    }
  }

  function dateLongue() {
    try {
      return new Intl.DateTimeFormat(lang, { weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit', timeZone: PARIS }).format(new Date(end));
    } catch (e) {
      return '';
    }
  }

  var QUAND = quand();
  var DATE = dateLongue();

  /* Construit une fois le contenu d'un emplacement ; ensuite seul le texte du compteur change. */
  function build(el) {
    var type = el.getAttribute('data-gh-rebours');
    var tpl = (type === 'bandeau' || type === 'urgence') ? T.bandeau
      : (type === 'fiche' && QUAND ? String(T.fiche || '').replace('__QUAND__', QUAND) : T.panier);
    tpl = String(tpl || '');
    if (tpl.indexOf('__RESTE__') < 0) return null;
    var vu = tpl.split(' · ').map(function (p) {
      return '<span class="gh-rebours__p">' + esc(p).replace('__RESTE__', '<b class="gh-rebours__t"></b>') + '</span>';
    }).join('<span class="gh-rebours__pt"> · </span>');
    el.innerHTML =
      (DATE && T.a11y ? '<span class="gh-rebours__sr">' + esc(String(T.a11y).replace('__DATE__', DATE)) + '</span>' : '') +
      (type === 'bandeau' ? '' : HORLOGE) +
      '<span class="gh-rebours__vu" aria-hidden="true">' + vu + (type === 'bandeau' ? ' ★' : '') + '</span>';
    return el.querySelector('.gh-rebours__t');
  }

  /* Met a jour tous les emplacements presents dans la page. Rend true tant que la promo court. */
  function maj() {
    var t = now();
    var actif = (start === null || t >= start) && t < end;
    var txt = actif ? reste(end - t, true) : '', txtCourt = actif ? reste(end - t, false) : '', txtHorloge = actif ? resteHorloge(end - t) : '';
    var els = document.querySelectorAll('[data-gh-rebours]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var type = el.getAttribute('data-gh-rebours');
      if (!actif || !ON[type === 'urgence' ? 'bandeau' : type]) {
        /* fini ou pas commence : on vide. La fiche garde sa hauteur reservee (pas de saut). */
        if (el.firstChild) el.textContent = '';
        el._ghT = null;
        el.classList.remove('is-actif');
        if (type !== 'fiche') el.hidden = true;
        continue;
      }
      if (!el._ghT || !el.contains(el._ghT)) el._ghT = build(el);
      if (!el._ghT) continue;
      var ce = type === 'bandeau' ? txtCourt : (type === 'urgence' ? txtHorloge : txt);
      if (el._ghT.textContent !== ce) el._ghT.textContent = ce;
      if (el.hidden) el.hidden = false;
      el.classList.add('is-actif');
    }
    return actif;
  }

  function tick() {
    if (timer) { clearTimeout(timer); timer = null; }
    var t = now();
    maj();
    if (t >= end) {
      if (!ended) {
        ended = true;
        /* le panier retire les cadeaux et reprend sa barre habituelle */
        setTimeout(function () { try { cart._render(); } catch (e) { /* rien */ } }, 1600);
      }
      return;
    }
    var wait;
    if (start !== null && t < start) {
      wait = Math.min(start - t + 200, 3600000);
    } else {
      var r = end - t;
      /* chaque seconde (les secondes defilent sur la fiche et le panier) */
      wait = r % 1000 + 30;
    }
    timer = setTimeout(tick, wait);
  }

  /* onglet remis au premier plan, retour arriere du navigateur : on recale tout de suite */
  document.addEventListener('visibilitychange', function () { if (!document.hidden && !ended) tick(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted && !ended) tick(); });

  window.ghRebours = { maj: maj };
  tick();
})();
